// extracted by mini-css-extract-plugin
export default {"wrapper":"series_wrapper__CsD+B","title":"series_title__u8tuN","filters":"series_filters__Go6t9","rangePicker":"series_rangePicker__7Mugh"};